module.exports = {"421321101":"厉山镇","421321102":"高城镇","421321103":"殷店镇","421321104":"草店镇","421321105":"小林镇","421321106":"淮河镇","421321107":"万和镇","421321108":"尚市镇","421321109":"唐县镇","421321110":"吴山镇","421321111":"新街镇","421321112":"安居镇","421321113":"澴潭镇","421321114":"洪山镇","421321115":"长岗镇","421321116":"三里岗镇","421321117":"柳林镇","421321118":"均川镇","421321119":"万福店镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421321.json
// module id = 1638
// module chunks = 0